import React, { useState, useEffect, useContext } from 'react';
import WizardContentParent from './WizardContentParent';
import SearchAndList from './SearchAndList';
import SelectedProteins from './SelectedProteins';
import WizardProteinTreeDataSupplier from 'business/tree/WizardProteinTreeDataSupplier';
import { isNullOrUndefined } from 'utils/Global';
import WizardService from 'business/services/WizardService';
import ScreenWizardContext from './ScreenWizardContext';
import { TreeNodeDTO } from 'business/models/Models';
import Explorer, { TreeControlDefaultState, TreeControlState } from 'components/explorer';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

const shouldRenderNode = (node) => {
  if (node.type === ETreeNodeTypes.RecycleBin) {
    return null;
  }
  return node;
};
function SelectProteinWizard({
  commonTreeNodes,
  gSelectedNode,
  plateType,
  selectedParentNode,
}: any) {
  const [isProDisabled, setProDisabled] = useState(false);
  const ALL_SCREENNODE_IDS = commonTreeNodes.length > 0 ? gSelectedNode.id : 3;
  const screenWizContext = useContext(ScreenWizardContext);
  let lTreeNodes = [];

  if (commonTreeNodes.length > 0) {
    lTreeNodes = [commonTreeNodes[1]];
  }
  const defaultTreeNode = new TreeNodeDTO();
  defaultTreeNode.id = ALL_SCREENNODE_IDS;
  const [parentNode, setParentNode] = useState({ id: ALL_SCREENNODE_IDS });
  const [proteinInfo, setProteinInfo] = useState([]);
  const globalTreeNodes = { treeNodes: [] };
  const [treeControlState, setTreeControlState] = useState<TreeControlState>({
    ...TreeControlDefaultState,
    selectedNodes: [`node${gSelectedNode}`],
  });

  const [listData, setListData] = useState(null);

  useEffect(() => {
    if (!(proteinInfo.length === 0)) {
      screenWizContext.setWizardDataDirty(true);
    }
  }, [proteinInfo]);

  function isProteinsFull() {
    const lProteins = screenWizContext.proteins;
    const dropsLength = screenWizContext.plateType?.enabledDropNumbers.length;
    if (lProteins.length === 0) {
      return false;
    } else if (lProteins.length < dropsLength) {
      return false;
    } else if (lProteins.length == dropsLength) {
      const slotEmty = lProteins.findIndex((protein) => protein == null);
      let isNullProtein = -1;
      if (slotEmty == -1) {
        isNullProtein = lProteins.findIndex((protein) => protein.name == undefined);
      }
      if (slotEmty != -1 || isNullProtein != -1) {
        return false;
      }
      if (slotEmty == -1) {
        return true;
      } else {
        return true;
      }
    }
  }

  useEffect(() => {
    setProDisabled(isProteinsFull());
  }, [screenWizContext.proteins]);

  useEffect(() => {
    if (isNullOrUndefined(parentNode)) {
      return;
    }
    async function fetchData() {
      const serv = new WizardService();
      const plateTypeId = plateType.id;
      const response = await serv.getWizardProteins(parentNode.id, plateTypeId);
      if (response != null) {
        setListData(response);
      }
    }
    fetchData();
  }, [parentNode]);

  return (
    <div id='selectproteinwizard-wrapper' className="flex" style={{ height: '100%', width: '100%' }}>
      <WizardContentParent
        id="selectproteinwizard-define-location"
        style={{ height: '90%', flex: '6', marginLeft: '0px', paddingTop: 0 }}
        heading="Define Protein Location"
        childStyle={{ paddingBottom: '8%' }}
      >
        <Explorer
          setParentNode={setParentNode}
          showQuickAccessNode={false}
          setParentSelectedNode={undefined}
          openClicked={undefined}
          dataSupplier={WizardProteinTreeDataSupplier}
          globalTreeNodes={globalTreeNodes}
          commonTreeNodes={lTreeNodes}
          gSelectedNode={ALL_SCREENNODE_IDS}
          treeControlState={treeControlState}
          setTreeControlState={setTreeControlState}
          shouldRenderNode={shouldRenderNode}
          treeNodeIdToLoadTree={selectedParentNode?.id}
        />
      </WizardContentParent>
      <WizardContentParent
        id="selectproteinwizard-search-section"
        style={{ height: '90%', flex: '7', marginLeft: '22px', paddingTop: '0px' }}
        heading="Search Proteins"
        childStyle={{ paddingBottom: '2%' }}
      >
        <SearchAndList
          id="selectproteinwizard-searchandlist-component"
          listData={listData}
          parentTreeId={parentNode.id}
          setData={setProteinInfo}
          buttonDisabled={isProDisabled}
          placeholder="Search protein..."
        />
      </WizardContentParent>
      <WizardContentParent
        id="selectproteinwizard-selected-section"
        style={{
          height: '90%',
          flex: '8',
          padding: '0px',
          marginLeft: '22px',
        }}
        heading="Selected Protein(s)"
        headingStyle={{ paddingLeft: '13px' }}
        childStyle={{ paddingBottom: '8%' }}
        className="screen-wizard-table wizard-select-protein-table"
      >
        <SelectedProteins  id="selectproteinwizard-selectedproteins-component" item={proteinInfo} />
      </WizardContentParent>
    </div>
  );
}

export default SelectProteinWizard;
